<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  numbersOfIdentify: Number,
  identifyValuesLabel: String,
  name: String,
  id: String,
  maxChars: {
    type: Number,
    default: 50
  },
  values: {
    type: Array,
    default: () => []
  },
});
const emit = defineEmits(['validate']);
const localValues = ref([]);

function updateValue(index, value) {
  emit('validate', {
       index,
       values: localValues.value
  });
}

watch(
  () => [props.numbersOfIdentify, props.values],
  ([count, newValues]) => {
    localValues.value = Array.from({ length: count }, (_, i) => newValues[i] ?? '');
  },
  { immediate: true, deep: true }
)
</script>
<template>
  <template v-for="(n, index) in props.numbersOfIdentify" :key="index">
    <div class="form-group mt-5">
      <label class="active" :for="`${props.id}${index + 1}`">{{index + 1}}) {{props.identifyValuesLabel}}</label>
      <input
        type="text"
        :maxlength="maxChars"
        :name="`${props.name}${index + 1}`"
        :id="`${props.id}${index + 1}`"
        v-model="localValues[index]"
        :required="props.required"
        @input="updateValue(index + 1, $event.target.value)"
        :data-yup-label="`${index + 1}) ${props.identifyValuesLabel}`"
      />
    </div>
  </template>
</template>
